/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/**
 * author: tman
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ButtonToolbar, ToggleButtonGroup, ToggleButton, HelpBlock } from 'react-bootstrap';
import ItemTitle from '../ItemTitle';

const RadioButton = (props) => {
  const {
    handleRadioChange,
    content
  } = props;
  const questionObj = {
    questionMark: content.questionMark,
    question: content.question,
    questionTip: content.questionTip
  };
  const handleOnChangeAction = (newVal) => {
    handleRadioChange(content.questionRel, newVal)
  };
  const questionTitle = content.question && content.question.title &&content.question.title;
  const errorId = content.radioItems[0].dataKey + '0-err';

  return (
    <div className="radio-box">
      <FormGroup validationState={content.isError ? 'error' : null}>
        { content.question && content.question.title &&
        <ItemTitle content={questionObj} isNeedLabel={false} />
        }
        <ButtonToolbar>
          <ToggleButtonGroup
            onChange={ handleOnChangeAction }
            type="radio"
            name={ content.radioName }
            value={ content.defaultValue }
            className="radio-decoration"
            role={'group'}//group
            aria-label={questionTitle || 'questionTitle'}//A string value marks the current element.
          >
            { content.radioItems.map((item, i) =>
              <ToggleButton
                data-key={ item.dataKey }
                data-index={ item.dataIndex }
                key={ i }
                disabled={ content.isDisabled }
                value={ item.value }
                aria-label={ content.ariaLabel || questionTitle+' '+(item.display && item.display) }
                aria-describedby={ `${item.dataKey}${i}-err ${item.dataKey}${i}-tip` }
              >
                <i className="before-icon"></i>
                { item.display && item.display }
                { item.displayTip &&
                  <p className="item-display-tip" id={ `${item.dataKey}${i}-tip` }>{item.displayTip}</p>
                }
              </ToggleButton>
            )}
          </ToggleButtonGroup>
        </ButtonToolbar>
        <HelpBlock id={ errorId }>{ content.errorMessage }</HelpBlock>
      </FormGroup>
    </div>
  )
};
RadioButton.propTypes = {
  content: PropTypes.object.isRequired,
  handleRadioChange: PropTypes.func,
};
RadioButton.defaultProps = {
  content: {}
};
export default RadioButton;


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/RadioButton/RadioButton.js